(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setView(root, showFull) {
      var button = root.querySelector('[data-ig-toggle]');
      var highlights = root.querySelector('[data-ig-highlights]');
      var full = root.querySelector('[data-ig-full]');
      if (!button || !highlights || !full) return;

      highlights.hidden = showFull;
      full.hidden = !showFull;
      // The button label stays the same; only its expanded state changes.
      button.setAttribute('aria-expanded', showFull ? 'true' : 'false');
    }

    // Delegated, so it keeps working when the theme editor re-renders the section.
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-ig-toggle], [data-ig-close]');
      if (!trigger) return;

      var root = trigger.closest('[data-ig]');
      if (!root) return;

      if (trigger.hasAttribute('data-ig-close')) {
        setView(root, false);

        // The X is hidden along with the list, so hand focus back to the button.
        var toggle = root.querySelector('[data-ig-toggle]');
        if (toggle) toggle.focus({ preventScroll: true });
        return;
      }

      setView(root, trigger.getAttribute('aria-expanded') !== 'true');
    });

    // Theme editor: selecting a highlight block brings the highlights back into view.
    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest('[data-ig]');
      if (root) setView(root, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumiiya-legal-text"] && !Shopify.designMode) return;
  try {
    
  /* Delegated once per page; works for every Lumiiya Legal section on the page
     and survives section re-renders in the theme editor. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lang-toggle]');
    if (!button) return;

    var section = button.closest('.lumiiya-legal');
    if (!section) return;

    var lang = button.getAttribute('data-lang-toggle');

    // One attribute on the section switches every bilingual paragraph via CSS.
    section.setAttribute('data-lang', lang);

    section.querySelectorAll('[data-lang-toggle]').forEach(function (btn) {
      btn.setAttribute(
        'aria-pressed',
        btn.getAttribute('data-lang-toggle') === lang ? 'true' : 'false'
      );
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumiiya-routine-ingredients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('routine-ingredients-step')) {
    // Remembers which steps have the full list open / are expanded on mobile, so the
    // state survives the theme editor re-rendering the section (e.g. while typing).
    const openSteps = new Set();
    const expandedSteps = new Set();

    // The accordion (one card open at a time) only applies on mobile, where the cards
    // are collapsible. Must match `@media screen and (max-width: 749px)` in the stylesheet.
    const mobileMQ = window.matchMedia('(max-width: 749px)');

    // ----- Anchor handling (#ingredients) -----

    // Returns the routine-ingredients section a hash points to, or null.
    const sectionForHash = (hash) => {
      if (!hash || hash.length < 2) return null;
      let id;
      try {
        id = decodeURIComponent(hash.slice(1));
      } catch (error) {
        return null;
      }
      const element = document.getElementById(id);
      return element && element.hasAttribute('data-ri-section') ? element : null;
    };

    // Expands every step card of the section (mobile; no visible change on larger
    // screens). The full ingredient list is left closed — the user toggles it. This
    // is the one case where all cards are open at once: setExpanded() is called
    // without `exclusive`, so no card closes another.
    const openAllSteps = (section) => {
      section.querySelectorAll('routine-ingredients-step').forEach((step) => {
        if (typeof step.setExpanded !== 'function') return;
        step.setExpanded(true);
      });
    };

    const scrollToSection = (section) => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      section.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    };

    // Same-page links to the anchor: open everything, then scroll to the section start.
    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const link = event.target.closest('a[href*="#"]');
      if (!link) return;

      let url;
      try {
        url = new URL(link.getAttribute('href'), location.href);
      } catch (error) {
        return;
      }
      if (url.origin !== location.origin || url.pathname !== location.pathname) return;

      const section = sectionForHash(url.hash);
      if (!section) return;

      event.preventDefault();
      openAllSteps(section);
      if (location.hash !== url.hash) history.pushState(null, '', url.hash);
      scrollToSection(section);
    });

    // Hash set programmatically (e.g. a <button> that sets location.hash) or via back/forward.
    window.addEventListener('hashchange', () => {
      const section = sectionForHash(location.hash);
      if (section) openAllSteps(section);
    });

    class RoutineIngredientsStep extends HTMLElement {
      connectedCallback() {
        this.expandButton = this.querySelector('[data-ri-expand]');
        this.toggle = this.querySelector('[data-ri-toggle]');
        this.panel = this.querySelector('[data-ri-panel]');
        this.closeButton = this.querySelector('[data-ri-close]');

        this.controller = new AbortController();
        const { signal } = this.controller;

        // ----- Mobile expand / collapse -----
        // A tap on the chevron is the user opening a card, so it closes the others.
        if (this.expandButton) {
          this.expandButton.addEventListener(
            'click',
            () => this.setExpanded(!this.isExpanded, { exclusive: true }),
            { signal }
          );
        }

        // ----- Full ingredient list panel -----
        if (this.toggle && this.panel) {
          this.toggle.addEventListener('click', () => this.setOpen(!this.isOpen), { signal });

          if (this.closeButton) {
            this.closeButton.addEventListener('click', () => this.close(), { signal });
          }
        }

        this.addEventListener(
          'keydown',
          (event) => {
            if (event.key !== 'Escape') return;
            if (this.isOpen) {
              this.close();
            } else if (this.isExpanded && this.expandButton) {
              this.setExpanded(false);
              this.expandButton.focus();
            }
          },
          { signal }
        );

        // Theme editor: selecting the step or one of its highlights shows the content
        // the way a customer would see it, so the other cards close on mobile.
        this.addEventListener(
          'shopify:block:select',
          (event) => {
            if (event.target !== this) this.setOpen(false);
            this.setExpanded(true, { exclusive: true });
          },
          { signal }
        );

        if (openSteps.has(this.dataset.blockId)) this.setOpen(true);
        if (expandedSteps.has(this.dataset.blockId)) this.setExpanded(true);

        // Page loaded (or section re-rendered) with #ingredients in the URL:
        // the browser scrolls to the anchor itself, we just expand the card.
        // Every step does this, so all cards end up open — the anchor exception.
        // The full ingredient list stays closed.
        if (sectionForHash(location.hash) === this.closest('[data-ri-section]')) {
          this.setExpanded(true);
        }
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
      }

      // --- expanded: mobile card open/closed ---

      get isExpanded() {
        return this.hasAttribute('expanded');
      }

      // exclusive: collapse the other cards of this section first (a user opening a
      // card on mobile). Not passed by openAllSteps() or the #ingredients handling,
      // so the anchor can show every card at once; the next user tap on a chevron
      // is exclusive again and collapses the rest as usual.
      setExpanded(expanded, { exclusive = false } = {}) {
        if (expanded && exclusive && mobileMQ.matches) {
          const section = this.closest('[data-ri-section]');
          if (section) {
            section.querySelectorAll('routine-ingredients-step').forEach((step) => {
              if (step !== this && step.isExpanded) step.setExpanded(false);
            });
          }
        }

        this.toggleAttribute('expanded', expanded);
        if (this.expandButton) this.expandButton.setAttribute('aria-expanded', String(expanded));

        if (expanded) {
          expandedSteps.add(this.dataset.blockId);
        } else {
          expandedSteps.delete(this.dataset.blockId);
        }
      }

      // --- open: full ingredient list panel ---

      get isOpen() {
        return this.hasAttribute('open');
      }

      setOpen(open) {
        if (!this.toggle || !this.panel) return;

        this.toggleAttribute('open', open);
        this.toggle.setAttribute('aria-expanded', String(open));
        this.panel.hidden = !open;

        // The panel lives inside the body, so make sure the card is expanded on mobile.
        if (open) this.setExpanded(true);

        if (open) {
          openSteps.add(this.dataset.blockId);
        } else {
          openSteps.delete(this.dataset.blockId);
        }
      }

      close() {
        this.setOpen(false);
        this.toggle.focus();
      }
    }

    customElements.define('routine-ingredients-step', RoutineIngredientsStep);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumiiya-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lumiiya-video')) {
  customElements.define(
    'lumiiya-video',
    class LumiiyaVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        // Autoplay policies check the property, not only the attribute.
        this.video.muted = true;
        this.video.defaultMuted = true;

        this.inView = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotionChange = () => this.sync();
        this.reducedMotion.addEventListener('change', this.onMotionChange);

        // A display:none element never intersects, so the hidden device variant stays paused
        // and the pair swaps cleanly when the viewport crosses the breakpoint.
        this.observer = new IntersectionObserver(
          (entries) => {
            this.inView = entries[entries.length - 1].isIntersecting;
            this.sync();
          },
          { threshold: 0.1 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.reducedMotion) this.reducedMotion.removeEventListener('change', this.onMotionChange);
      }

      // Plays only while on screen; stays on the poster frame for visitors with reduced motion enabled.
      sync() {
        if (this.inView && !this.reducedMotion.matches) {
          const playing = this.video.play();
          if (playing) playing.catch((error) => this.retryOnInteraction(error));
        } else {
          this.video.pause();
        }
      }

      // Autoplay can be blocked (e.g. iOS Low Power Mode): start on the visitor's first tap instead.
      retryOnInteraction(error) {
        if (!error || error.name !== 'NotAllowedError' || this.waitingForInteraction) return;
        this.waitingForInteraction = true;
        const retry = () => {
          this.waitingForInteraction = false;
          if (this.isConnected) this.sync();
        };
        document.addEventListener('touchend', retry, { once: true, passive: true });
        document.addEventListener('click', retry, { once: true });
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();
})();
